import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { modifySoftOrder } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const TimeOfDayTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tacticId = tradePlanStore.tradePlans[tradePlanId].setupFilters['TIME_OF_DAY']?.tacticId ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const startHour = softOrder?.value.tacticValue.startHour ?? null;
    const startMinute = softOrder?.value.tacticValue.startMinute ?? null;
    const endHour = softOrder?.value.tacticValue.endHour ?? null;
    const endMinute = softOrder?.value.tacticValue.endMinute ?? null;

    const updateSoftOrder = (type, value) => {
      modifySoftOrder({ softOrder, type, value });
    };
    

    if (!tacticId || !softOrder) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Start Hour
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={startHour}
                    updateValue={(newValue) =>
                      updateSoftOrder('startHour', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Start Minute
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={startMinute}
                    updateValue={(newValue) =>
                      updateSoftOrder('startMinute', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    End Hour
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={endHour}
                    updateValue={(newValue) =>
                      updateSoftOrder('endHour', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    End Minute
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={endMinute}
                    updateValue={(newValue) =>
                      updateSoftOrder('endMinute', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

TimeOfDayTacticPanel.tabsRole = 'TabPanel';
